var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DEFAULT_BACKGROUND_COLOR, } from '../common';
import { setAlignment, setButtonIcon, hasClass, getWidgetSettings } from './helpers';
import { setPopUp, closePopUp } from './popUp/popUp';
import './widget.css';
import './popUp/popUp.css';
class Widget {
    constructor() {
        this.container = document.createElement('div');
        this.button = document.createElement('button');
        this.iframeWrapper = document.createElement('div');
        this.iframe = document.createElement('iframe');
        this.notificator = document.createElement('div');
        this.html = document.querySelector('html');
        this.notificatorCounter = 0;
        this.visualParams = null;
        this.serverParams = null;
        this.CLASS_NAME = 'temporary-widget-class';
        this.setIsOpenButton = setButtonIcon(this.button);
    }
    initChat(paramData, user) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!paramData.server || !paramData.clientId || !paramData.host)
                return;
            const paramsServer = paramData.server.replace(/^(http|https):\/\//, '');
            const widgetSettings = yield getWidgetSettings(paramsServer, paramData.clientId);
            if (!widgetSettings)
                return;
            if (!this.visualParams)
                this.setParams(widgetSettings);
            this.createButtonAndIframeOnPage(paramData, paramsServer);
            this.serverParams = {
                server: paramsServer,
                host: paramData.host,
                init: true,
                user,
                initParamData: Object.assign({}, paramData),
            };
            this.setIsOpenButton = setButtonIcon(this.button, widgetSettings.open_button_color || undefined);
            this.setIsOpenButton(false);
            sessionStorage.setItem('serverParams', JSON.stringify(this.serverParams));
            this.addEventListeners();
            if (this.visualParams)
                this.initialWidget(widgetSettings.open_button_color, user);
            if (widgetSettings.open_button_horizontal_alignment)
                this.iframeWrapper.classList.add(`${widgetSettings.open_button_horizontal_alignment}-open`);
            setPopUp({
                isActive: widgetSettings.popup_is_active,
                title: widgetSettings.popup_title,
                text: widgetSettings.popup_text,
                interval: widgetSettings.popup_interval,
                position: widgetSettings.open_button_horizontal_alignment || 'right',
            }, {
                appendCallback: (popUpContent) => this.container.insertAdjacentHTML('beforeend', popUpContent),
                openWidget: () => this.openWidget(),
            });
        });
    }
    setUserAccount(email, name) {
        const iframeDoc = this.iframe.contentWindow;
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ userData: { email, name, type: 'userData' } }, '*');
    }
    createButtonAndIframeOnPage(paramData, paramsServer) {
        const meta = document.createElement('meta');
        meta.name = 'viewport';
        meta.content = 'user-scalable=no, initial-scale=1.0, maximum-scale=1.0, width=device-width';
        document.head.appendChild(meta);
        this.container.classList.add(`${this.CLASS_NAME}__container`);
        this.button.classList.add('class', `${this.CLASS_NAME}__button`);
        this.button.setAttribute('aria-label', 'Open Widget');
        this.iframeWrapper.classList.add(`${this.CLASS_NAME}__iframe-wrapper`);
        this.iframeWrapper.classList.add('iframe-wrapper-hidden');
        this.iframe.setAttribute('scrolling', 'no');
        this.iframe.setAttribute('id', 'widgetIframe');
        this.iframe.setAttribute('name', 'widgetIframe');
        this.iframe.setAttribute('title', 'Iframe with widget');
        const protocol = paramsServer.includes('localhost:') ? 'http://' : 'https://';
        const prefix = paramData.server ? `${protocol}${paramsServer}` : '';
        this.iframe.setAttribute('src', `${prefix}/index.html?id=${paramData.clientId}&clientUrl=${parent.location.href}`);
        this.iframeWrapper.appendChild(this.iframe);
        /** Временно решили скрыть счетчик входящих сообщений. Видимо потом должны вернуть */
        // this.container.appendChild(this.notificator);
        this.container.appendChild(this.iframeWrapper);
        this.html.appendChild(this.container);
        this.listenChatMessages();
    }
    setParams(params) {
        this.visualParams = { setParams: true, params };
        if (this.serverParams)
            this.initialWidget(params.open_button_color);
        this.setIsOpenButton = setButtonIcon(this.button, params.open_button_color || undefined);
        setAlignment(this.container, params.open_button_horizontal_alignment);
    }
    disableNameAndEmailInput(isDisabledNameAndEmail) {
        const iframeDoc = this.iframe.contentWindow;
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ isDisabledNameAndEmail }, '*');
    }
    setCustomFields(customFields) {
        const iframeDoc = this.iframe.contentWindow;
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ customFields }, '*');
    }
    addEventListeners() {
        this.button.addEventListener('click', () => {
            closePopUp();
            if (!hasClass(this.container, 'is-iframe-shown'))
                return this.openWidget();
            this.closeWidget();
        }, false);
        window.addEventListener('keyup', (event) => {
            if (event.keyCode === 27) {
                this.closeWidget();
            }
        });
        window.addEventListener('message', (msg) => {
            if (msg.data.link && msg.data.link.href) {
                window.open(msg.data.link.href, '_blank');
            }
            if (msg.data && msg.data.type === 'close widget') {
                this.closeWidget();
            }
        });
    }
    listenChatMessages() {
        /* listen messages from iframe JS */
        window.addEventListener('message', (msg) => {
            if (msg.data && msg.data.type === 'new message')
                this.handleNewMessage();
        }, false);
    }
    handleNewMessage() {
        if (!hasClass(this.container, 'is-iframe-shown')) {
            const counter = ++this.notificatorCounter;
            if (!hasClass(this.notificator, 'visible'))
                this.notificator.classList.add('visible');
            this.notificator.textContent = counter.toString();
        }
    }
    closeWidget() {
        var _a;
        const iframeDoc = this.iframe.contentWindow;
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ isOpen: false }, '*');
        (_a = this.setIsOpenButton) === null || _a === void 0 ? void 0 : _a.call(this, false);
        this.container.classList.remove('is-iframe-shown');
        this.iframeWrapper.classList.add('iframe-wrapper-hidden');
        this.iframeWrapper.classList.remove('iframe-wrapper-shown');
    }
    openWidget() {
        this.container.classList.add('is-iframe-shown');
        this.iframeWrapper.classList.add('iframe-wrapper-shown');
        this.iframeWrapper.classList.remove('iframe-wrapper-hidden');
        this.notificatorCounter = 0;
        this.notificator.textContent = '';
        this.notificator.classList.remove('visible');
        this.sayIframeIsOpen();
    }
    sayIframeIsOpen() {
        var _a;
        const iframeDoc = this.iframe.contentWindow;
        (_a = this.setIsOpenButton) === null || _a === void 0 ? void 0 : _a.call(this, true);
        iframeDoc === null || iframeDoc === void 0 ? void 0 : iframeDoc.postMessage({ isOpen: true }, '*');
    }
    initialWidget(color, user) {
        this.iframe.onload = () => {
            var _a, _b;
            const iframeDoc = this.iframe.contentWindow;
            this.notificator.setAttribute('class', 'temporary-widget-class__notificator');
            this.notificator.style.setProperty('--notificator-color', color || DEFAULT_BACKGROUND_COLOR);
            if (!iframeDoc || !this.visualParams)
                return;
            this.visualParams.params.blocks = ((_b = (_a = this.visualParams.params) === null || _a === void 0 ? void 0 : _a.blocks) === null || _b === void 0 ? void 0 : _b.length)
                ? this.visualParams.params.blocks
                : ['chat'];
            /* setTimeout нужен чтобы в React успевал отрендериться компонент App и подписаться на событие 'message' */
            setTimeout(() => {
                // Передаем данные приложению App
                iframeDoc.postMessage({ serverParams: this.serverParams, visualParams: this.visualParams, user }, '*');
            }, 200);
            this.container.appendChild(this.button);
        };
    }
}
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
window.Happydesk = new Widget();
// @ts-ignore
window.Pulsedesk = new Widget();
/* eslint-enable */
